import type { FaireProductEntity } from "../../entity_types/product";

export const atc_nf_chunks_6: FaireProductEntity = {
  token: "atc_nf_chunks_6",
  type: "product",
  name: "Cloud Barrette",
  brandName: "Chunks",
  imageUrl:
    "https://cdn.shopify.com/s/files/1/0510/2698/5143/products/Barrette-CloudClip-WBG-web-1-updated.jpg?v=1675261934",
  priceDollars: 12.95,
  msrpDollars: 26,
  description: "ATC migration seed product",
  tags: ["hair", "accessories", "chunks"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
